<template>
 <section class="hero">
    <div class="hero-body">
      <div class="container">
        <h1 class="title">
                Registi
        </h1>
            <div style="cursor:pointer">
              <b-table :data="rowData" :columns="columns"
                  :striped=true
                  :paginated="true"
                  :backend-pagination="true"
                  :backend-filtering="true"
                  :total="total"
                  :current-page.sync="page"
                  :per-page="perPage"
                  :pagination-simple="false"
                  :selected.sync="selected"
                  @filters-change="setFilter"
                  @select="select"
                  @page-change="onPageChange"
                  >
                <b-input
                  slot="searchable"
                  slot-scope="props"
                  v-model="props.filters[props.column.field]"
                  placeholder="Cerca..."
                  icon="magnify"
                  size="is-small" 
                />
              </b-table>
            </div>
              <b-table :data="mRowData" :columns="mColumns"  @select="jump"
                  :striped="true"
              />

      </div>
    </div>
  </section>
</template>

<script>
import api from "../api/api.js";
import helpers from "../helpers.js";

let emptyVal = null;


export default {
  name: 'friend',
  methods: {
    getData () {
      const loading = this.$buefy.loading.open();
      api.director.getPaginated((this.page-1)*10,10, this.filter)
      .then ((rows)=>{
        this.rowData = rows.data;
        loading.close();
      })
    },
    getMoviesData() {
      if (!this.selectedItem) return;
      const loading = this.$buefy.loading.open();
      api.vision.getByDirector(this.selectedItem.Id)
      .then ((rows)=>{
        let newRows = rows.data.sort((a,b)=>{return a.Ext_show.Date_seen<b.Ext_show.Date_seen})
        this.mRowData = helpers.flattenVisions(newRows, this.$store.state);
        loading.close();
      })
    },
    getTotal () {
      api.director.getTotal(this.filter)
      .then ((rows)=>{
        this.total = rows.data;
      })
    },
    getMode () {
      const loading = this.$buefy.loading.open();
      api.mode.getAll()
      .then ((rows)=>{
        this.lovs.mode = rows.data;
        loading.close();
      })
    },
    rowClicked(row) {
      if (row.id==this.selectedItem.id) {
         this.selected = null;
         this.selectedItem = emptyVal;
       }
        
    },
    setFilter(flt) {
      this.page = 1;
      this.filter=flt.Name;
      this.getData();
      this.getTotal();
    },
    select(row) {
       this.selectedItem = row;
       this.getMoviesData();
    },
    jump(row) {
      this.$store.state.jumpId = row.Id
      this.$router.push('Vision')
    },
    onPageChange(page){
      this.page = page;
      this.getData();
    }
  },
  data() {
        return {
            selectedRow: null,
            selectedItem: emptyVal,
            rowData: [],
            mRowData:[],
            page: 1,
            perPage: 10,
            total:0,
            lovs:{mode:[]},
            selected: null,
            selectedTab: 0,
            columns: [
                {
                    field: 'Id',
                    label: 'id',
                    width: '40',
                    numeric: true
                },
                {
                    field: 'Name',
                    label: 'Nome',searchable: true
                }
            ],
            mColumns: [
                {
                    field: 'Full_title',
                    label: 'Titolo',
                    sortable: true
                },
                {
                  field: 'Date_seen',
                  label: 'Data',
                  sortable: true
                },
                {
                  field: 'Full_mode',
                  label: 'Modo'
                },
                {
                  field:'Dicks',
                  label: 'Cazzetti',
                  sortable:true
                }

            ]
        }
    },
    mounted() {
      this.getData();
      this.getTotal();
      this.lovs.service = this.$store.state.services
      this.lovs.city = this.$store.state.cities
      this.lovs.language = this.$store.state.languages
      this.lovs.mode = this.$store.state.modes
    }
}
</script>

<style>

</style>